import React, { PureComponent } from "react";
import Http from "../../networkReq/http";
import Request from "../../networkReq/request";
import {showhtml} from  'utils/methods'
require("./index.scss");
export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      info: {},
      time: "",
      attachment: [],
      beforeArticle: "",
      nextArticle: ""
    };
  }

  componentDidMount = () => {
    const {
      location: { search }
    } = this.props;
    const id = search.substring(1);

    Http.get(Request.articleDetail(), { id }, obj => {
      if (obj && obj.code == 200) {
        let { data } = obj;
        let timeCreate = data.article.createTime.split(" ")[0];
        this.setState(
          {
            info: data.article,
            attachment: data.annex,
            beforeArticle: data.beforeArticle,
            nextArticle: data.nextArticle,
            time: timeCreate
          },
          () => {}
        );
      }
    });
    
  };

  
  download(pre) {
    let id = pre.id;
    window.location = `http://yhbest.imwork.net:30080/blade-portal/articleUtils/downloadSingFile?id=${id}`;
  }

  goDetail(id, e) {
    e.preventDefault();
    this.props.history.replace("/preferential/preferentialPolicyDetail?" + id);
    window.location.reload()
  }

  render() {
    const { info, time, attachment, beforeArticle, nextArticle } = this.state;

    return (
      <div>
        {/* 详情 */}
        <div className="details">
          <div className="container">
            <div className="details_title">{info.title}</div>
            <div className="details_tips">
              <span>信息来源：</span>
              <span>{info.fromurl}</span>
              <span>发布日期：</span>
              <span>{time}</span>
            </div>
            <div className="details_cont">
              <div className="details_cont_text">
                {showhtml(info.content)}
              </div>
              <div className="details_cont_accessory">
                {attachment.length > 0
                  ? attachment.map((item, index) => {
                      return (
                        <div key={index}>
                          附件 {index + 1}：
                          <div
                            className="underline"
                            style={{ display: "inline-block" }}
                            onClick={() => this.download(item)}
                          >
                            {item.annexName}
                          </div>
                        </div>
                      );
                    })
                  : null}
              </div>
              <div className="flip">
                <div>
                  上一篇：
                  {beforeArticle != "" ? (
                    <a onClick={this.goDetail.bind(this, beforeArticle.id)}>
                      {beforeArticle.title}
                    </a>
                  ) : (
                    <span>没有文章了</span>
                  )}{" "}
                </div>
                <div>
                  下一篇：
                  {nextArticle != "" ? (
                    <a onClick={this.goDetail.bind(this, nextArticle.id)}>
                      {nextArticle.title}
                    </a>
                  ) : (
                    <span>没有文章了</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* 详情 */}
      </div>
    );
  }
}
